module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageTitle":"Онлайн-собеседование на вакансию"}}')
  delete Component.options._Ctor
}
